import { render, staticRenderFns } from "./w-tab-pane.vue?vue&type=template&id=009b700e&"
import script from "./w-tab-pane.vue?vue&type=script&lang=ts&"
export * from "./w-tab-pane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports